import { useEffect } from 'react';

const INITIAL_LOADER_ID = 'initial-loader-container';

/** Removes the static HTML loading shell once React has mounted its own loader. */
export const useRemoveInitialLoader = () => {
  useEffect(() => {
    document.getElementById(INITIAL_LOADER_ID)?.remove();
  }, []);
};
